import { registerFirstTime, gotoGame } from "../../js/api/liveCasino.js";

let LiveCasino = {
    render: async () => {
        let view =  /*html*/`
            <iframe style="width:100%;min-height: calc(100vh - 50px);" src="data:text/html,<h1></h1>" id="gameIframe" frameborder="0" noresize="noresize" allow="geolocation 'self'; autoplay 'self'"></iframe>
        `
        return view;
    },
    after_render: async () => {
        let userId = localStorage.getItem('user_id');
        let starGameId = localStorage.getItem("starGameId");
        const response = await registerFirstTime();
        if (response && response.token !== null) {
            localStorage.setItem('access_token', response.token.jwt);
        }

        if (!(starGameId == null || starGameId == undefined || starGameId == '')) {
            let checkStatus = await gotoGame();
            if (checkStatus.success == true) {
                const key1 = checkStatus.key1;
                const key2 = checkStatus.key2;
                const sessionid = checkStatus.sessionid;
                const gameId = 11;
                const gameLink = `https://apiserver.solutions/showgame?gameid=${gameId}&sid=${sessionid}&key1=${key1}&key2=${key2}&username=${userId}&uwidth=auto&uheight=auto`;
    
                $('#gameIframe').attr('src', gameLink);
            }
        }


    },
    on_unload: async (socket) => {
        document.querySelector('meta[name="viewport"]').setAttribute("content", 'width=device-width, initial-scale=1');
    },
}

export default LiveCasino;
